<template>
  <div>
    <div>
      <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Client User List</b-navbar-brand>
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard mb-2 p-0">
          <b-card-text>
            <b-row>
              <b-col md="3">
                <b-button
                  v-if="selectedClients.length >= 0"
                  @click="SaveClient"
                  variant="primary"
                  class="pull-right"
                  >Save</b-button
                >
                <input
                  type="checkbox"
                  class="ml-2 mr-2"
                  @click="SelectAll($store.getters['common/getAllMultiClientList'])"
                  v-model="isCheckAll"
                />
                <label>Select / Deselect All Count({{ selectedClients.length }})</label>
              </b-col>
              <b-col md="9" v-if="$sessionsStorage.get('getUsermultiClientName')">
                <label>Selected Client:</label>
                <b-row>
                <b-col md="4" v-for="(item, index) in  $sessionsStorage.get('getUsermultiClientName').split(',')"  :key="index">
                {{parseInt(index+1)+". "+item}}
                </b-col>
                </b-row>
                </b-col></b-row
          ></b-card-text>
        </b-card>
        <b-card class="formCard userClient">
          <b-card-text>
            <div class="mt-3">
              <b-row>
                <!-- {{selectedClients}} -->
                <b-col
                  md="4"
                  v-for="(item, index) in $store.getters['common/getAllMultiClientList']"
                  :key="index"
                >
                  <input
                    type="checkbox"
                    v-model="selectedClients"
                    :value="item.value"
                    :id="'userClient' + index"
                    :name="'userClient' + index"
                    @change="updateSelectAll($event, item)"
                  />
                  <label :for="'userClient' + index"> {{ item.text }}</label>
                  <!-- <input v-model="" type="checkbox" v-model="selectedClients" class="mb-3"
                  :value="item.value" size="lg" disabled-field="notEnabled"
                  @change="updateSelectAll($event, option)" /> -->
                  <!-- <label>{{ item.text }}</label> -->
                </b-col>
                <!-- <b-form-checkbox-group
                  v-model="selectedClients"
                  :options="$store.getters['common/getAllMultiClientList']"
                  class="mb-3"
                  value-field="value"
                  text-field="text"
                  size="lg"
                  disabled-field="notEnabled"
                  @change="updateSelectAll($event, option)"
                ></b-form-checkbox-group> -->
                <br />
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      );
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      );
      this.$store.dispatch(
        "common/setAllMultiClientList",
        JSON.stringify({
          itemCode: "MultiClientList",
          userID:this.$sessionsStorage.get("getUserID"),
        })
      );
      if (globalPermissionStatus("Client User") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Client User")
        );
        globalPermissionStatus("Client User");
        this.$store.dispatch("setCurrentRoute", "/client/user");
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      isCheckAll: false,
      selectedClients: this.$sessionsStorage.get("getAlacc_client_ids")
        ? this.$sessionsStorage.get("getAlacc_client_ids").split(",")
        : [],
      selectedUserID: this.$sessionsStorage.get("getUserID")
        ? this.$sessionsStorage.get("getUserID")
        : 0,
      ExcelBtnName: "Export",
      adminToggle: this.$sessionsStorage.get("designation"),
      isLoading: false,

      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      validate: true,
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    MultiSelect,
  },

  computed: {},
  methods: {
    SaveClient() {
      if (this.selectedClients.length > 0 && this.selectedUserID > 0) {
        let payload = {
          itemCode: "updateMultiClientDetails",
          TypeofAdd: "User Master Update",
          fk_multi_client_id: this.selectedClients,
          user_id: this.selectedUserID,
        };
        payload = JSON.stringify(payload);
        // return false;
        ClientUserService.getAllClientUserList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200) {
              console.log("data=>", data);
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.selectedClients = [];
              let allClient = data.fk_multi_client_id;
              this.selectedClients = allClient.split(",");
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    SelectAll: function () {
      console.log(
        "this.User List=>",
        this.$store.getters["common/getAllMultiClientList"]
      );
      this.isCheckAll = !this.isCheckAll;
      this.selectedClients = [];
      if (this.isCheckAll) {
        // Check all
        this.$store.getters["common/getAllMultiClientList"].forEach((element) => {
          console.log("key=>", element);
          this.selectedClients.push(element.clientId);
        });

        console.log("this.selectedClients=>", this.selectedClients);
      }
    },
    updateSelectAll: function (e, item) {
      console.log("ids", e);
      console.log("ids", item);
      if (
        this.selectedClients.length ==
        this.$store.getters["common/getAllMultiClientList"].length
      ) {
        this.isCheckAll = true;
      } else {
        // this.selectedClients = e;
        this.isCheckAll = false;
      }
      console.log("this.selectedClients=>", this.selectedClients);
    },
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.userClient .card-body {
  height: 75vh;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// viewClientList.vue?e1553098